import { ReadonlyURLSearchParams } from 'next/navigation';

import { DEFAULT_PRODUCER_COLOR_CODE } from '../constants';

export type ProductActionIntent =
   | { type: 'quote'; colorId: number; colorCode?: string }
   | { type: 'call-off'; colorId: number; colorCode?: string }
   | { type: 'small-lot'; colorId: number; colorCode?: string }
   | { type: 'rfq'; colorId: number; colorName: string; colorCode?: string }
   | { type: 'none' };

const parseColorId = (rawColorId: string | null): number | undefined => {
   if (!rawColorId) return undefined;

   const parsedColorId = Number(rawColorId);
   return Number.isFinite(parsedColorId) ? parsedColorId : undefined;
};

export const parseProductActionIntent = (searchParams: ReadonlyURLSearchParams | URLSearchParams): ProductActionIntent => {
   const from = searchParams.get('from');
   const colorId = parseColorId(searchParams.get('colorId'));
   if (!colorId) return { type: 'none' };

   const colorCode = searchParams.get('colorCode') ?? undefined;

   if (from === 'quote') return { type: 'quote', colorId, colorCode };
   if (from === 'call-off') return { type: 'call-off', colorId, colorCode };
   if (from === 'small-lot') return { type: 'small-lot', colorId, colorCode };

   const colorName = searchParams.get('color') ?? undefined;
   if (from === 'rfq' && colorName) return { type: 'rfq', colorId, colorName, colorCode: colorCode ?? DEFAULT_PRODUCER_COLOR_CODE };

   return { type: 'none' };
};

export const resolveRfqUrlSelection = (searchParams: ReadonlyURLSearchParams | URLSearchParams) => {
   const intent = parseProductActionIntent(searchParams);
   return intent.type === 'rfq' ? intent : undefined;
};
